import React from "react";
import { Box, Typography } from "@mui/material";

import CustomIconButton from "components/CustomIconButton/CustomIconButton";
import { useAuth } from "hooks/useAuth";

import email from "../../assets/icons/email-icon.svg";
// import chat from "../../assets/icons/chat-icon.svg";
import userImg from "../../assets/user.png";

const ProfileSection = ({ sendEmailHandler }) => {
  const { user } = useAuth();

  return (
    <>
   {user && <>
    <img
        src={userImg}
        alt="User_Image"
        className="mt-6 w-[80px] h-[80px] mx-auto"
      />
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 500,
          color: "#080F1A",
          textAlign: "center",
          mt: "12px"
        }}
      >
        Yogesh Chourasiya
      </Typography>
      <Typography
        sx={{
          fontSize: "12px",
          color: "#5C626C",
          textAlign: "center",
          mt: "0px"
        }}
      >
        Your Underwriting Operations Contact
      </Typography>
      </>}
      <Box
        sx={{
          display: "flex",
          gap: "10px",
          mt: user ? "1rem" : '6rem'
        }}
      >
        <CustomIconButton
          img={email}
          title="Email"
          action={sendEmailHandler}
          alt="email"
        />
        {/* <CustomIconButton
          img={chat}
          title="Chat"
          action={openChatHandler}
          alt="chat"
        /> */}
      </Box>
    </>
  );
};

export default ProfileSection;
